import React from "react";
import PropTypes from "prop-types";
import "./StatusBadge.css";

const StatusBadge = ({ status, statusLabel, style }) => {
  const isActive = status === "active";
  return (
    <span style={style} className={`status-badge ${isActive ? "active" : "inactive"}`}>
      {statusLabel ? statusLabel : isActive ? "نشط" : "غير نشط"}
    </span>
  );
};

StatusBadge.propTypes = {
  status: PropTypes.string,
  statusLabel: PropTypes.string,
  style: PropTypes.object,
};

export default StatusBadge;